exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  font-weight: 300; }\n\n.warning {\n  font-style: italic;\n  color: #e22d43; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/remaining-text-indicator/remaining-text-indicator.component.scss
// module id = ../../../../../src/app/shared/components/remaining-text-indicator/remaining-text-indicator.component.scss
// module chunks = 12